/* file description */
/* file description */

import React from 'react';
import SpBusinessBtns from '../../sp-business-btns';
import useMetaStore from '@/store/useMetaStore';
import { useSPFormWithModelSchemaReturnType } from '@/components/SPTabList/TabPage/useSPFormWithModelSchema';
import { FreeBtnClickProps } from './useFreeBtnClick';

interface useOptionsColumnsProps {
  freeButtonClick: ({ btnInfo, open }: FreeBtnClickProps, ctx?: {}) => void;
  selectedRows: Record<string, any[]>;
}

export const useOptionsColumns = ({ freeButtonClick, selectedRows }: useOptionsColumnsProps) => {
  const sotreState = useMetaStore((state) => state);
  const { pageConfig, pageType, utils } = sotreState;

  const createOtionsColums = (config: useSPFormWithModelSchemaReturnType) => {
    const extraButtonList = pageConfig?.freeBtnConfig?.filter((config: Record<string, any>) => config?.position == 'module') ?? [];
    const rowFreeBtns = extraButtonList
      .filter((item) => item['position-direction'] === 'row')
      .filter((item) => item['position-module'] === config.props.moduleID);

    const btnsClick = (val: FreeBtnClickProps, ctx: any) => {
      freeButtonClick(val, ctx);
    };

    if (rowFreeBtns.length === 0) {
      return null;
    }

    return {
      title: '操作',
      valueType: 'option',
      dataIndex: 'options',
      fixed: 'right',
      width: 50 * (rowFreeBtns?.length || 1),
      align: 'center',
      num: rowFreeBtns.length,
      render: (_text, record, index) => {
        return React.createElement(
          SpBusinessBtns,
          {
            utils: { ...utils },
            btnInfo: rowFreeBtns,
            btnsClick: (val) => btnsClick(val, {
              rowData: record,
              rowIndex: index,
              selectedRows: selectedRows[config?.props.moduleID] || [] }),
            record,
            moduleID: config?.props.moduleID,
          } as any,
          null,
        );
      },
    };
  };

  return {
    createOtionsColums,
  };
};
